/**
 * MODULE: domain/sales-presentations/contracts/presentation-template-categories.ts
 * PURPOSE: Canonical presentation template category values (seed + library filters + create modals).
 * PUBLIC_API: PRESENTATION_TEMPLATE_CATEGORIES, PresentationTemplateCategory
 * AGENT_SAFETY: SAFE
 * RECENT: [2.2.1100] — PACK H: align UI (8) with seed_templates.json / README (was 5 in create flows).
 */

export const PRESENTATION_TEMPLATE_CATEGORIES = [
  { value: 'pitch-deck', label: 'Pitch Deck' },
  { value: 'account-plan', label: 'Account Plan' },
  { value: 'proposal', label: 'Proposal' },
  { value: 'qbr', label: 'QBR' },
  { value: 'case-study', label: 'Case Study' },
  { value: 'training', label: 'Training' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'internal', label: 'Internal' },
] as const;

export type PresentationTemplateCategory =
  (typeof PRESENTATION_TEMPLATE_CATEGORIES)[number]['value'];

export const PRESENTATION_TEMPLATE_CATEGORY_VALUES: PresentationTemplateCategory[] =
  PRESENTATION_TEMPLATE_CATEGORIES.map((c) => c.value);
